export default __webpack_public_path__ + "static/media/circle.e0f78046.svg";